import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import bundleActions from '@redux/bundle/actions';
import { RootState } from '@redux/reducer';

const { fetchBundleCoursesAction } = bundleActions;

const useBundleCourseItem = () => {
  const dispatch = useDispatch();
  const { bundleCoursesState } = useSelector((state: RootState) => ({
    bundleCoursesState: state.Bundle.get('bundleCoursesState'),
  }));

  const handleFetchBundleCourses = (bundleIdOrIdName: string) => {
    dispatch(fetchBundleCoursesAction.request({ bundleIdOrIdName }));
  };

  const handleResetBundleCourses = () => {
    dispatch(fetchBundleCoursesAction.reset());
  };

  const {
    data: bundleCoursesData,
    isLoading: isBundleCoursesLoading,
    isSuccess: isBundleCoursesSuccess,
    isError: isBundleCoursesError,
  } = bundleCoursesState;

  const { bundleCourses } = useMemo(() => {
    return {
      bundleCourses: bundleCoursesData || [],
    };
  }, [bundleCoursesData]);

  return {
    bundleCourses,
    isBundleCoursesLoading,
    isBundleCoursesSuccess,
    isBundleCoursesError,
    handleFetchBundleCourses,
    handleResetBundleCourses,
  };
};

export default useBundleCourseItem;
